import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'
// import { IconLeftSmall } from '@paypalcorp/dx-ui-react'
import data from '../../../../content/home/home.en-XC.yaml'
import QrCode from '../../../../icons/qrCode'
import Calculator from '../../../../icons/calculator'
import Flag from '../../../../icons/flag'

import './style.css'

const AdditionalSolutions = () => {
  const { tiles } = data.content.additional_solutions || []

  const Icons = {
    QrCode: <QrCode />,
    Calculator: <Calculator />,
    Flag: <Flag />,
  }

  return (
    <section className="additionalSolutions">
      <Container>
        <Row>
          <Col>
            <h3 className="additionalSolutionsHeader floatCol">
              {data.content.additional_solutions.title}
            </h3>
          </Col>
        </Row>
        <Row>
          {tiles.map((tile, key) => {
            return (
              <Col xs={12} md={4} className="floatCol iconLeftSmall" key={key}>
                <div className="headerIcon">
                  <div className="iconWrapper">{Icons[tile.icon]}</div>
                  <h4 className="infoTitle">{tile.title}</h4>
                </div>
                <p className="additionalSolutions-txt">{tile.description}</p>
                <a href={tile.url} className="getStarted">
                  {}
                  {tile.linkText}
                </a>
              </Col>
            )
          })}
        </Row>
      </Container>
    </section>
  )
}

export default AdditionalSolutions
